import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'filter-unit',
  templateUrl: './filter-unit.component.html',
  styleUrls: ['./filter-unit.component.css']
})
export class FilterUnitComponent implements OnInit {

  @Output() filterUnitClicked: EventEmitter<any> = new EventEmitter();

  filter: {
    building: string,
    floor: string,
    unit: string,
  }
  =
  {
    building: '',
    floor: '',
    unit: '',
  }

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  changePickerStatus(){
    this.filterUnitClicked.emit(this.filter)
  }

}
